import React from 'react'

import { P } from '../../../../style/Typography.style'

import Flex from '../../../layouts/Flex'

import Table from '../../../Table'

const InterviewScorecard = ({ title, columns, data, score, rating }) => {
  return (
    <>
      <P
        textTransform="uppercase"
        marginTop="2rem"
        marginBottom="1rem"
        weight="500"
        size=".875rem"
      >
        {title}
      </P>

      <Table
        data={data}
        columns={columns}
        fetchData={() => {}}
        enablePagination={false}
        enableSort={false}
        height="auto"
        onClick={() => {}}
      />

      <Flex justify="flex-end" gap="2rem">
        <Flex direction="column" gap="0.25rem">
          <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
            {title} Score:
          </P>
          {rating && (
            <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
              Rating:
            </P>
          )}
        </Flex>
        <Flex direction="column" gap="0.25rem" items="flex-end">
          <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
            {score}
          </P>
          {rating && (
            <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
              {rating}
            </P>
          )}
        </Flex>
      </Flex>
    </>
  )
}

export default InterviewScorecard
